import React, { FunctionComponent, useContext } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { AuroraMobilePromo, AuroraPromo, LyraSelectMobilePromo, LyraSelectPromo } from '../../assets/microsite'
import { ProductTypeContext, ThemeType } from '../../utils'
import { ImageComponentProps } from '../formElements/RadioButtons'
import { Image } from '../image/Image'
import mobileAppPromo from './../../assets/mobile-app-promo.png'

const MobileAppPromoIllustrationPNG = styled(Image)<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
  resizeMode: 'contain',
}))

export const MobileAppPromoIllustration: FunctionComponent<ImageComponentProps> = ({ width = 448, height = 440 }) => {
  const { isLyraSelect } = useContext(ProductTypeContext)
  const {
    breakpoints: { isMobileSized },
    isAuroraTheme,
  } = useTheme() as ThemeType

  if (isAuroraTheme) {
    const auroraSource = isMobileSized ? AuroraMobilePromo : AuroraPromo
    const auroraHeight = isMobileSized ? Math.round((width * 585) / 567) : Math.round((width * 926) / 896)
    return <MobileAppPromoIllustrationPNG source={auroraSource} width={width} height={auroraHeight} />
  }

  const lyraSelectAppPromo = isMobileSized ? LyraSelectMobilePromo : LyraSelectPromo
  const imageSource = isLyraSelect ? lyraSelectAppPromo : (mobileAppPromo as ImageSourcePropType)
  return <MobileAppPromoIllustrationPNG source={imageSource} width={width} height={height} />
}
